'use strict';

function DashboardApplication() {
  this.id = null;
  this.node = null;
  this.extends = [_MoneyController];
  this.loanStateRoutingEnabled = true;

  this.init = function () {
    this._super();
    this._checkForNotifications();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._applyAnalytics();
    if (this._getApplicationStatus().status === 'agreements') {
      this._agreementsStatus = this._getAgreementsStatus();

      this.presenter.addComputedVariable('agreementsStatus', ['money.loans.fs_loans'], function () {
        return this._getAgreementsStatus();
      }.bind(this, this._agreementsStatus));

      if (this._agreementsStatus === 'pending') {
        this._startAgreementsPolling();
      }
    }

    this._debugDetails();
  };

  this._checkForNotifications = function () {
    var notification = getURLParameter('notification').trim();
    if (notification === 'application-resubmitted') {
      $('#Notification').mogo().create({
        type: 'warning',
        msg: 'Your changes have not been saved. To make changes to your application, please chat with us before signing your agreements.'
      });
      datalayer.push({ event: 'DLevent.ResignAgreementsErrorNotification' });
    }
  };

  this._startAgreementsPolling = function () {
    // poll BE for 60 seconds to see if agreements have been generated yet:
    if (!this._agreementsPollingCallbackId) {
      // Start polling if we haven't already
      this._agreementsPollingCallbackId = this.presenter.addCallbackToAction('money.loans.self', this._checkAgreementsPolling.bind(this));
      // poll every 6 seconds, for 1 minute
      this.presenter.startPoll('money.loans', 6000, 10);
    }
  };

  this._checkAgreementsPolling = function (data, response) {
    if (response === 200) {
      var _status = data.fs_loans.agreements.status;
      var _pollStatus = this.presenter.getPollStatus('money.loans.self'); // not working as expected.
      if (_status === 'ready') {
        this._applyAnalytics(); // status has changed, send analytics event
        this.presenter.stopPoll('money.loans');
      } else if (_status === 'error') {
        this._applyAnalytics(); // status has changed, send analytics event
        this.presenter.stopPoll('money.loans');
      } else if (_pollStatus['money.loans.self'].iterations === 0) {
        // LoanActions already takes care of this based on status = error but...
        // we temporarily/manually force them to this state early in case BE takes longer than 1 minute
        data.fs_loans.agreements.status = 'error';
        this._applyAnalytics(); // status has changed, send analytics event
      }
      this.presenter.updateModel('money.loans', data);
    } else {
      $('#Notification').mogo().get();
    }
  };

  // Analytics:
  this._applyAnalytics = function () {
    var subview = '';
    if (this._agreementsStatus === 'pending') {
      subview = '-agreements-generating';
    } else if (this._agreementsStatus === 'error') {
      subview = '-agreements-email';
    } else if (this._agreementsStatus === 'ready') {
      subview = '-agreements-sign';
    }

    // must come before other analytics event
    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [window.location.href + subview]
    });

    if (this.presenter.models.money.loans.fs_loans.agreements.type === 'auto') {
      this.analytics.pushEvent('loan-agreement-automation', {
        automatedAgreement: ['mini']
      });
    }
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this.destroy = function () {
    this.presenter.stopPoll('money.loans');
    this.presenter.removeComputedVariable('agreementsStatus');

    if (this._agreementsPollingCallbackId) {
      this.presenter.removeCallbackFromAction('money.loans.self', this._agreementsPollingCallbackId);
      this._agreementsPollingCallbackId = null;
    }
  };
}